module.exports = __webpack_public_path__ + "img/payout-icon.0187e1ed.svg";